<template>
  <div class="collapsable-icon-list mb-2 mb-md-0">
    <div class="button" role="button" tabindex="0">
      <strong class="d-inline-block"
        >{{ title }}
        <span
          v-if="titleTooltip"
          class="d-none d-md-inline ms-1 cece-tooltip-html tooltip-right lh-1"
        >
          <IconQuestionmark />
          <span class="tooltip-content">
            {{ titleTooltip }}
            <a
              v-if="titleTooltipReadMoreLink"
              target="_blank"
              :href="titleTooltipReadMoreLink"
            >
              {{ $i18n.productModal.readMore }}
            </a>
          </span>
        </span>
      </strong>
      <ul>
        <li v-for="(item, index) in items" :key="index">
          <img
            class="m-0 me-1"
            :src="item.icon"
            :title="item.text"
            :alt="item.text"
          />
        </li>
      </ul>
      <span class="show-more-icon">
        <IconChevronDown />
        <span class="show-more">
          {{ $i18n.productModal.showMore }}
        </span>
      </span>
    </div>
    <ul class="content">
      <li v-for="(item, index) in items" :key="index">
        <span class="d-flex align-items-center" target="_blank">
          <img
            class="m-0 me-1"
            :src="item.icon"
            :title="item.text"
            :alt="item.text"
          />
          <component
            :is="item.link ? 'a' : 'span'"
            :href="item.link"
            class="label"
          >
            {{ item.text }}
          </component>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import IconChevronDown from '../../../../templates/icons/chevron-down.svg';
import IconQuestionmark from '../../../../templates/icons/questionmark.svg';

export default {
  components: {
    IconChevronDown,
    IconQuestionmark,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    titleTooltip: {
      type: String,
      default: '',
    },
    titleTooltipReadMoreLink: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
